import { DatePicker } from "@/components/ui/date-picker";
import { parseSelectableDate } from "@/components/utils/dateUtils";
import { DayAxis, dayIndexFromKey, dayKeyFromIndex, isTemplateAxis } from "../models/day-axis";
import { DaySelect } from "./DaySelect";

const toDate = (value?: string | Date): Date | undefined =>
  value instanceof Date ? value : parseSelectableDate(value);

interface DayFieldProps {
  /** Asse dell'itinerario: decide se si sceglie una data reale o un giorno relativo. */
  axis?: DayAxis | null;
  date?: string;
  dayIndex?: number | null;
  onDateChange: (date: string) => void;
  onDayIndexChange?: (index: number) => void;
  placeholder: string;
  /** Accetta sia una data ISO sia un Date: i chiamanti hanno l'una o l'altro. */
  minDate?: string | Date;
  maxDate?: string | Date;
  hasError?: boolean;
  disabled?: boolean;
  /** Primo giorno selezionabile in modalità template (es. non prima della partenza). */
  minIndex?: number;
  /** Giorni oltre la durata selezionabili (il check-out cade dopo l'ultima notte). */
  extraDays?: number;
  /** Classi aggiuntive sul controllo: serve a smontarne il bordo dentro i box a righe. */
  className?: string;
}

/**
 * Il giorno di un'attività: date picker su un itinerario collegato a una travel
 * request, selettore "Giorno N" su un template, che di date non ne ha.
 *
 * Esiste perché la scelta fra i due era copiata in ogni modale che chiede un giorno.
 */
export const DayField = ({
  axis,
  date,
  dayIndex,
  onDateChange,
  onDayIndexChange,
  placeholder,
  minDate,
  maxDate,
  hasError = false,
  disabled = false,
  minIndex = 1,
  extraDays = 0,
  className = '',
}: DayFieldProps) => {
  if (isTemplateAxis(axis)) {
    return (
      <DaySelect
        axis={axis}
        value={dayIndex ? dayKeyFromIndex(axis, dayIndex) : null}
        onSelect={(key) => onDayIndexChange?.(dayIndexFromKey(axis, key))}
        placeholder={placeholder}
        hasError={hasError}
        disabled={disabled}
        minIndex={minIndex}
        extraDays={extraDays}
        className={className}
      />
    );
  }

  return (
    <DatePicker
      value={date}
      onSelect={onDateChange}
      placeholder={placeholder}
      hasError={hasError}
      minDate={toDate(minDate)}
      maxDate={toDate(maxDate)}
      isDisabled={disabled}
      compact
      className={className}
    />
  );
};
